// API Configuration
// Automatically detects environment and uses appropriate API URL

const getApiUrl = () => {
  // Check if running in production (deployed site)
  const hostname = window.location.hostname;
  
  if (hostname === 'big5.zainlee.com' || hostname === 'www.big5.zainlee.com') {
    return 'https://big5.zainlee.com/api';
  }
  
  // Development environment
  return 'http://localhost:5000/api';
};

export const API_URL = getApiUrl();

export default {
  API_URL,
  TIMEOUT: 30000,
};

